module.exports = __webpack_public_path__ + "static/media/buscircle2x.f4fa837d.png";